"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
const slip10wallet_1 = require("./slip10wallet");
class Ed25519HdWallet extends slip10wallet_1.Slip10Wallet {
    constructor() {
        super(...arguments);
        this.implementationId = "ed25519-hd";
    }
    static fromEntropy(bip39Entropy) {
        return super.fromEntropyWithCurve(crypto_1.Slip10Curve.Ed25519, bip39Entropy, Ed25519HdWallet);
    }
    static fromMnemonic(mnemonicString) {
        return super.fromMnemonicWithCurve(crypto_1.Slip10Curve.Ed25519, mnemonicString, Ed25519HdWallet);
    }
    clone() {
        return new Ed25519HdWallet(this.serialize());
    }
}
exports.Ed25519HdWallet = Ed25519HdWallet;
//# sourceMappingURL=ed25519hdwallet.js.map